module.exports = __webpack_public_path__ + "static/media/app.f06534f3.png";